import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useCopyCalendar = ({ onSuccess }) => {
  const { onSubmit: handleCopyCalendar } = useFetch(
    'copy-calendar',
    Api.CALENDAR_CREATE
  );

  const onCopyCalendar = (name) => () =>
    handleCopyCalendar({ body: { name }, onSuccess });

  return {
    onCopyCalendar,
  };
};

export default useCopyCalendar;
